import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                        */
const CampaignInfoBanner = ({ className, text, icon, ...rest }) => /* @__PURE__ */ React.createElement("div", { className: classnames("campaign-info-banner", className), ...rest }, /* @__PURE__ */ React.createElement("div", { className: "campaign-info-banner__constrained-box" }, icon && /* @__PURE__ */ React.createElement(Icon, { name: icon, width: 18, height: 18 }), /* @__PURE__ */ React.createElement("p", { className: "typography-text typography-text--caption campaign-info-banner__constrained-box__text" }, text)));
export {
  CampaignInfoBanner as default
};
//# sourceMappingURL=CampaignInfoBanner.js.map
